export default __webpack_public_path__ + "static/about-sparkle-f8f61569f6446d70a82a5717af32079a.svg";